/// <reference path="../../app.definition.ts" />

/*
* eCareVault.IAppStateService
* author: Ian Tripp
*/
import angular from "angular";
import { IFeedService } from "./feed.service";
import { SubjectService } from "./subject.service";
import { UserService } from "./user.service";
import { CacheService } from "./cache.service";
export interface IAppStateService {
    getState(key: string): any;
}

export class AppStateService implements IAppStateService {
    svcName: string = 'eCareVault.AppStateService';

    // Functions that can gather information about the current state of the application
    // Can be used anywhere throughout the app without having to inject each requirement
    // into every controller
    appStates = {
        ISIE11: (): boolean => {
            return angular.element('html').hasClass('ie11');
        },
        CR_SELECTED: (bool: boolean) => !!this.$_cache.currentSubject == bool,
        CR_FORMER: (bool: boolean) => !!this.$_cache.currentSubject && this.$_cache.currentSubject.isFormerTeamMember == bool,
        CR_FROZEN: (bool: boolean) => !!this.$_cache.currentSubject && this.$_cache.currentSubject.isFrozen == bool,
        EMPTY_FEEDS: (bool: boolean) => !this.$_feed.getCachedFeedIds('posts')[0] == bool,
        NUM_CRS: (num: any) => this.compareNumbers(!!this.$_cache.subjects ? this.$_cache.subjects.length : 0, num || 0),
        NUM_INVITES: (num: any) => {
            // console.log("Number ov invitations:", !!this.$rootScope.pendingInvitations ? this.$rootScope.pendingInvitations.length : 0, "equals value?", this.compareNumbers(!!this.$rootScope.pendingInvitations ? this.$rootScope.pendingInvitations.length : 0, num || 0))
            return this.compareNumbers(!!this.$rootScope.pendingInvitations ? this.$rootScope.pendingInvitations.length : 0, num || 0)
        },
        CAN_INVITE_CR: (subject: any): boolean => {
            (subject == true || !subject) && (subject = this.$_cache.currentSubject || null);

            // console.log('AppState.CAN_INVITE_CR:', subject);

            if (!subject || !subject.ownerId || !subject.coCaptain) {
                return false;
            }

            if (subject.ownerId == this.$_user.getMyId() || subject.coCaptain) {
                return true;
            }

            return false;

        },
        SCREEN_SIZE: (str: string) => {
            let w = angular.element(window).innerWidth();

            if (Math.abs(w - 1024) < 5 && Math.abs(angular.element(window).innerHeight() - 1366) < 5) {
                return 'medium' == str;
            }

            return (w < 480 ? 'small' : w < 991 ? 'medium' : 'large') == str;
        }
    }

    // compare a number against another number or a string representing
    // an equality operator and a number
    private compareNumbers = (num1: number, num2: any): boolean => {
        if (num2 instanceof Number || typeof num2 === "number") {
            return num1 == num2;
        } else {
            if (num2.substring(0, 2) == '>=') {
                return num1 >= Number(num2.substring(2));
            } else if (num2.substring(0, 2) == '<=') {
                return num1 <= Number(num2.substring(2));
            } else if (num2.substring(0, 1) == '>') {
                return num1 > Number(num2.substring(1));
            } else if (num2.substring(0, 1) == '<') {
                return num1 < Number(num2.substring(1));
            } else {
                return num1 == Number(num2);
            }
        }
    }

    static $inject = ["CacheService", "FeedService", "$rootScope", "SubjectService", "UserService"];
    constructor(
        private $_cache: CacheService,
        private $_feed: IFeedService,
        private $rootScope,
        private $_subject: SubjectService,
        private $_user: UserService
    ) {
    }

    getState = (key: string): any => this.appStates[key] || null;

}

angular.module('eCareVault.common.services')
    .service('AppStateService', AppStateService);